


class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.variantChangeHandler = this.variantChangeHandler.bind(this);
  }

  connectedCallback() {
    // Variant card click — use div not radio so clicks always fire
    this.querySelectorAll('.esa__variant-card').forEach(card => {
      card.addEventListener('click', () => this.selectVariantCard(card));
    });

    // Subscribe / one-time radio toggle
    document.addEventListener('change', (e) => {
      if (e.target.name === 'selling_plan') {
        this.syncSellingPlanToForm();
      }
    });

    // Arch checkbox changes from theme
    document.querySelectorAll('.product-variant').forEach(el => {
      el.addEventListener('change', this.variantChangeHandler);
    });

    // Select first card on load
  //   const firstCard = this.querySelector('.esa__variant-card');
  //   if (firstCard) this.selectVariantCard(firstCard, true);

  //   this.syncSellingPlanToForm();
  // }

  // Select first card on load
    const firstCard = this.querySelector('.esa__variant-card');
    if (firstCard) this.selectVariantCard(firstCard, true);

    this.syncSellingPlanToForm();
    this.updateActiveOption();

    // Update active state whenever selling_plan changes
    document.addEventListener('change', (e) => {
      if (e.target.name === 'selling_plan') {
        this.updateActiveOption();
      }
    });
  }

  disconnectedCallback() {
    document.querySelectorAll('.product-variant').forEach(el => {
      el.removeEventListener('change', this.variantChangeHandler);
    });
  }

  selectVariantCard(card, silent = false) {
    // Remove active from all cards
    this.querySelectorAll('.esa__variant-card').forEach(c => c.classList.remove('active'));
    card.classList.add('active');

    const price     = card.dataset.price;
    const compare   = card.dataset.compare;
    const variantId = card.dataset.variantId;
    const sellingPlanId = card.dataset.sellingPlan;
    const subPrice  = card.dataset.subPrice;
    const subCompare = card.dataset.subCompare;

    // Update all hidden variant ID inputs on the page
    document.querySelectorAll('input[name="id"]').forEach(input => input.value = variantId);

    // Update one-time price in widget
    const oneTimeSale    = this.querySelector('.esa__one-time-box .esa__price .esa__sale_price');
    const oneTimeDel     = this.querySelector('.esa__one-time-box .esa__price del');
    if (oneTimeSale) oneTimeSale.textContent = this.formatMoney(price);
    if (oneTimeDel)  oneTimeDel.textContent  = this.formatMoney(compare);

    // Update subscribe price in widget
    const subSale = this.querySelector('.esa__subscription-box .esa__price .esa__sale_price');
    const subDel  = this.querySelector('.esa__subscription-box .esa__price del');
    if (subSale && subPrice)   subSale.textContent = this.formatMoney(subPrice);
    if (subDel  && subCompare) subDel.textContent  = this.formatMoney(subCompare);

    // Update selling plan radio value for subscribe option
    const subscribeRadio = this.querySelector('input[name="selling_plan"]:not([value=""])');
    if (subscribeRadio && sellingPlanId) subscribeRadio.value = sellingPlanId;

    // Update theme price block (the £129 / Save £21 section)
    const priceEl   = document.querySelector('.payment-plan-price .amount');
    const compareEl = document.querySelector('.payment-plan-price .previous-price');
    const saveEl    = document.querySelector('.payment-plan-price .save-price');
    if (priceEl)   priceEl.textContent   = `£${(price / 100).toFixed(0)}`;
    if (compareEl) compareEl.textContent = compare > 0 ? `£${(compare / 100).toFixed(0)}` : '';
    if (saveEl) {
      const saved = (compare - price) / 100;
      saveEl.textContent = saved > 0 ? `(Save £${saved.toFixed(0)})` : '';
    }

    this.syncSellingPlanToForm();
  }

  // Fetch updated widget when arch changes
  // variantChangeHandler() {
  //   const variantId = document.querySelector('input[name="id"]')?.value;
  //   if (!variantId) return;

  //   fetch(`${this.dataset.productUrl}?variant=${variantId}&section_id=${this.dataset.sectionId}`)
  //     .then(r => r.text())
  //     .then(html => {
  //       const doc = new DOMParser().parseFromString(html, 'text/html');
  //       const newWidget = doc.querySelector('.esa__subscription-container');

  //       if (newWidget) {
  //         this.style.display = 'block';
  //         this.querySelectorAll('input[name="selling_plan"]').forEach(el => el.disabled = false);

  //         const targets = [
  //           ['.esa__subscription-box .esa__price', 'innerHTML'],
  //           ['.esa__one-time-box .esa__price',     'innerHTML'],
  //           ['.esa__save-badge',                   'textContent'],
  //           ['.esa__subscription-benefits',        'innerHTML'],
  //           ['.esa__variant-cards',                'innerHTML'],
  //         ];
  //         targets.forEach(([sel, prop]) => {
  //           const src = newWidget.querySelector(sel);
  //           const dst = this.querySelector(sel);
  //           if (src && dst) dst[prop] = src[prop];
  //         });

  //         // Re-bind card clicks after innerHTML update
  //         this.querySelectorAll('.esa__variant-card').forEach(card => {
  //           card.addEventListener('click', () => this.selectVariantCard(card));
  //         });
  //         const firstCard = this.querySelector('.esa__variant-card');
  //         if (firstCard) this.selectVariantCard(firstCard, true);

  //       } else {
  //         this.style.display = 'none';
  //         this.querySelectorAll('input[name="selling_plan"]').forEach(el => el.disabled = true);
  //       }
  //     });
  // }

variantChangeHandler() {
  setTimeout(() => {
    const variantId = document.querySelector('input[name="id"]')?.value;
    console.log('[ESA widget] variantChangeHandler fired, variantId =', variantId);
    if (!variantId) return;

    const fetchUrl = `${this.dataset.productUrl}?variant=${variantId}&section_id=${this.dataset.sectionId}`;
    console.log('[ESA widget] fetching:', fetchUrl);

    fetch(fetchUrl)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newWidget = doc.querySelector('.esa__subscription-container');
        console.log('[ESA widget] newWidget found?', !!newWidget);

        if (newWidget) {
          this.style.display = 'block';
          this.querySelectorAll('input[name="selling_plan"]').forEach(el => el.disabled = false);

          console.log('[ESA widget] new price HTML:', newWidget.querySelector('.esa__one-time-box .esa__price')?.innerHTML);

          console.log('[ESA widget] subscribe price HTML:', newWidget.querySelector('.esa__subscription-box .esa__price')?.innerHTML);

          const targets = [
            ['.esa__subscription-box .esa__price', 'innerHTML'],
            ['.esa__one-time-box .esa__price',     'innerHTML'],
            ['.esa__save-badge',                   'textContent'],
            ['.esa__subscription-benefits',        'innerHTML'],
            ['.esa__variant-cards',                'innerHTML'],
          ];
          targets.forEach(([sel, prop]) => {
            const src = newWidget.querySelector(sel);
            const dst = this.querySelector(sel);
            if (src && dst) dst[prop] = src[prop];
          });

          // this.querySelectorAll('.esa__variant-card').forEach(card => {
          //   card.addEventListener('click', () => this.selectVariantCard(card));
          // });
          // const firstCard = this.querySelector('.esa__variant-card');
          // if (firstCard) this.selectVariantCard(firstCard, true);


          this.querySelectorAll('.esa__variant-card').forEach(card => {
            card.addEventListener('click', () => this.selectVariantCard(card));
          });
          const matchingCard = this.querySelector(`.esa__variant-card[data-variant-id="${variantId}"]`);

          console.log('[ESA widget] matchingCard found?', !!matchingCard, 'looking for variantId:', variantId);
if (matchingCard) {
  console.log('[ESA widget] matchingCard subPrice:', matchingCard.dataset.subPrice, 'subCompare:', matchingCard.dataset.subCompare);
}

          const cardToSelect = matchingCard || this.querySelector('.esa__variant-card');
          if (cardToSelect) this.selectVariantCard(cardToSelect, true);

        } else {
          this.style.display = 'none';
          this.querySelectorAll('input[name="selling_plan"]').forEach(el => el.disabled = true);
        }
      });
  }, 0);
}


  updateActiveOption() {
    this.querySelectorAll('.esa__subscription-option').forEach(option => {
      const radio = option.querySelector('input[name="selling_plan"]');
      if (radio && radio.checked) {
        option.classList.add('esa--active');
      } else {
        option.classList.remove('esa--active');
      }
    });
  }

  syncSellingPlanToForm() {
    const checked = document.querySelector('input[name="selling_plan"]:checked');
    const hidden  = document.getElementById('selected-selling-plan');
    if (hidden) hidden.value = checked ? checked.value : '';
  }

  formatMoney(pence) {
    const amount = (pence / 100);
    return `£${amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2)}`;
  }
}

customElements.define('subscription-widget', SubscriptionWidget);